<template>
  <v-container fluid>
    <div class="row">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <ListInvoices />
      </v-col>
    </div>
  </v-container>
</template>

<script>
import ListInvoices from '@/views/invoice/components/ListInvoices'

export default {
  name: 'Invoices',
  components: { ListInvoices },
}
</script>